import { css } from '@emotion/react';

export const defaultStyles = css`
    display: inline-block;

    .icon-right {
        float: right;
        margin-left: 0.5rem;
    }

    .icon-left {
        margin-right: 0.5rem;
    }
`;

export const themeStyles = css`
    button {
        font-size: var(--linkComponent-fontSize);
        font-weight: var(--linkComponent-fontWeight);
        font-family: var(--linkComponent-fontFamily);
        line-height: var(--linkComponent-lineHeight);
        color: var(--linkComponent-textColor);
        span {
            text-decoration: var(--linkComponent-textDecoration);
        }
    }

    :hover {
        button {
            color: var(--linkComponent-hoverTextColor);
        }
    }

    :visited {
        button {
            color: var(--linkComponent-visitedTextColor);
        }
    }

    :active {
        button {
            color: var(--linkComponent-activeTextColor);
        }
        span {
            border-style: var(--linkComponent-activeBorderStyle);
            border-color: var(--linkComponent-activeBorderColor);
            border-width: var(--linkComponent-activeBorderWidth);
        }
    }

    display: inline-block;

    .icon-right {
        float: right;
        margin-left: 0.5rem;
    }

    .icon-left {
        margin-right: 0.5rem;
    }
`;
